import { useContext } from "react";
import { ImagesSentSuccessContext } from "./context";
import { ImagesSentSuccessContextType } from "./types";

export const useImagesSentSuccessProvider = () => {
  const c = useContext<ImagesSentSuccessContextType | undefined>(
    ImagesSentSuccessContext
  );
  if (!c)
    throw new Error(
      "useImagesSentSuccessProvider must be used within ImagesSentSuccessProvider"
    );
  return c;
};
